export const LAYER_COLORS = [
    '#FAAD14',
    '#FA8C16',
    '#FADB14',
    '#1890FF',
    '#2F54EB',
    '#13C2C2',
    '#52C41A',
    '#EB2F96',
    '#FF4D4F',
    '#FF85C0',
    '#722ED1',
    '#2D3D54'
];
